import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export interface useCorretoresEmpresaVendasInterface {
  idPdv: string;
}

export function useEmpresasVendasPDV(
  props: useCorretoresEmpresaVendasInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const LISTAR_EMPRESAS_VENDAS_PDV = `dadoscomum/empresas-vendas-pdv/${props.idPdv}`;
    const response = await instance.get(LISTAR_EMPRESAS_VENDAS_PDV);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: true,
    onError: () => {
      toast.error("Erro ao listar empresas.");
    },
  });
  return query;
}
